import { Reveal } from "@/components/Reveal";
import { motion } from "framer-motion";
import { PREVIEWS } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Preview() {
  return (
    <section id="preview" className="relative scroll-mt-24 overflow-hidden py-20 sm:py-28" data-testid="preview">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="eyebrow">Product tour</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl">
            A closer look inside the vault
          </h2>
          <p className="mt-4 text-muted-foreground">
            Real screens from the Warranty_Vault pro app — your dashboard, receipts, notes, community and security, all in one place.
          </p>
        </Reveal>
      </div>

      <div className="mx-auto mt-12 max-w-7xl px-5 sm:px-8">
        <div
          className="flex snap-x snap-mandatory gap-5 overflow-x-auto pb-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:grid lg:grid-cols-5 lg:gap-4 lg:overflow-visible lg:pb-0"
          data-testid="preview-gallery"
        >
          {PREVIEWS.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: EASE }}
              className="group relative w-[260px] shrink-0 snap-start sm:w-[280px] lg:w-auto"
            >
              <div className="relative overflow-hidden rounded-[1.5rem] border border-border bg-card/50 shadow-xl transition-all duration-300 group-hover:-translate-y-1.5 group-hover:border-gold/40">
                <div className="pointer-events-none absolute -inset-10 -z-10 bg-sage/10 opacity-0 blur-3xl transition-opacity duration-300 group-hover:opacity-100" />
                <img src={p.img} alt={`${p.title} — Warranty_Vault pro app screen`} className="aspect-[3/4] w-full object-cover object-top" loading="lazy" />
              </div>
            </motion.article>
          ))}
        </div>
        <p className="mt-2 text-xs text-muted-foreground lg:hidden">
          Swipe to explore more screens →
        </p>
      </div>
    </section>
  );
}
